import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { OpportunitiesListComponent } from '@pages/opportunities/opportunities-list/opportunities-list.component';
import { FilterStateService } from '@services/filter-state.service';
import { IAdditionalFilterVisibilityConfig } from '@shared/additional-filters/additional-filters.config';
import { ModalSelectCompanyRolesComponent } from '@shared/modals/modal-select-company-roles/modal-select-company-roles.component';
import { OpportunitiesFiltersComponent } from '@shared/opportunities-filters/opportunities-filters.component';
import {
    IAdditionalFiltersOpportunities,
    IMainFiltersOpportunities,
    OPPORTUNITIES_COMPANY_FILTER_KEY
} from '@shared/opportunities-filters/opportunity-filters.config';
import { ModalService } from 'ngx-lib';

@Component({
    selector: 'app-companies-single-opportunities',
    templateUrl: './companies-single-opportunities.component.html',
    styleUrls: ['./companies-single-opportunities.component.scss'],
    imports: [OpportunitiesFiltersComponent, OpportunitiesListComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: FilterStateService,
            useClass: FilterStateService<IMainFiltersOpportunities, IAdditionalFiltersOpportunities>
        }
    ]
})
export class CompaniesSingleOpportunitiesComponent {
    readonly companyId = input.required<number>();

    readonly filtersKey = OPPORTUNITIES_COMPANY_FILTER_KEY;

    readonly filtersVisibility: IAdditionalFilterVisibilityConfig = {
        dueDate: true,
        expectedBookingDate: true,
        account: true,
        company: false,
        companyRole: true,
        potentialValue: true,
        proposedGrossMargin: true,
        probability: true,
        department: true,
        salesperson: true,
        status: true,
        includeArchived: true
    };

    isOpeningModal = false;

    private readonly modalService = inject(ModalService);
    private readonly router = inject(Router);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    async onNewOpportunityClicked(event: MouseEvent): Promise<void> {
        if (this.isOpeningModal) return;

        const trigger = event.currentTarget as HTMLButtonElement;
        let roleIds: number[] | undefined;

        this.isOpeningModal = true;
        try {
            roleIds = await this.modalService.open(ModalSelectCompanyRolesComponent);
        } finally {
            this.isOpeningModal = false;

            if (trigger.isConnected) {
                // Render the enabled state before restoring focus.
                this.changeDetectorRef.detectChanges();
                trigger.focus();
            }
        }

        if (!roleIds?.length) return;

        await this.router.navigate(['/opportunities-create'], {
            queryParams: {
                companyId: this.companyId(),
                companyRoleIds: roleIds.join(',')
            }
        });
    }
}
